import React from 'react';




// import * as Scroll from 'react-scroll';
import "./ListWrapper.scss";








import ScrollToBottom from 'react-scroll-to-bottom';



export default class ListWrapper extends React.Component<any> {
  render() {
    return <ScrollToBottom className="scc-ListWrapper" followButtonClassName="scc-SwivlFollowButton" scrollViewClassName="overflow-y-auto [&::-webkit-scrollbar]:bg-transparent [&::-webkit-scrollbar]:rounded-md [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-grey-400 [&::-webkit-scrollbar-thumb]:rounded-md">
      <React.Fragment>{this.props.children} </React.Fragment>
    </ScrollToBottom>;
  }
}